import styled from "styled-components"

export const GridContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 30px;
  overflow: hidden;
  padding-top: 96px;
  aspect-ratio: 2.125;
  margin-bottom: -100px;
  z-index: -100;
  @media (max-width: 992px) {
    grid-gap: 18px;
    padding-top: 56px;
    margin-bottom: -50px;
  }
  @media (max-width: 768px) {
    grid-gap: 10px;
    padding-top: 32px;
    margin-bottom: -40px;
  }
  .background {
    grid-area: 1 / 1 / 4 / 6;
    justify-self: center;
    align-self: center;
    width: 100%;
    height: 100%;
    margin-top: -12%;
    @media (max-width: 768px) {
      margin-top: -10%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .image {
    box-shadow: 0px 0px 64px 4px rgba(98, 221, 252, 0.25);
    border-radius: 16px;
    transition: all ease 0.25s;
    &:hover {
      transform: scale(1.05);
      box-shadow: 0px 0px 64px 4px rgba(98, 221, 252, 0.4);
    }
    @media (max-width: 992px) {
      box-shadow: 0px 0px 32px 4px rgba(98, 221, 252, 0.25);
      &:hover {
        box-shadow: 0px 0px 32px 4px rgba(98, 221, 252, 0.4);
      }
    }
    @media (max-width: 768px) {
      box-shadow: 0px 0px 24px 4px rgba(98, 221, 252, 0.25);
      &:hover {
        box-shadow: 0px 0px 24px 4px rgba(98, 221, 252, 0.4);
      }
      border-radius: 8px;
    }
    @media (max-width: 576px) {
      border-radius: 4px;
    }
    // NOTE: need the additional border radius for safari
    img {
      border-radius: 16px;
      @media (max-width: 768px) {
        border-radius: 8px;
      }
      @media (max-width: 576px) {
        border-radius: 4px;
      }
    }
  }
  .img-0 {
    grid-area: 1 / 1 / 2 / 3;
    width: 87%;
    height: 60%;
    justify-self: end;
    align-self: start;
  }
  .img-1 {
    grid-area: 1 / 3 / 2 / 4;
    width: 90%;
    height: 100%;
    justify-self: end;
    align-self: start;
  }
  .img-2 {
    grid-area: 1 / 4 / 2 / 6;
    width: 70%;
    height: 80%;
    margin-left: 10%;
  }
  .img-3 {
    grid-area: 1 / 1 / 3 / 3;
    width: 105%;
    height: 65%;
    justify-self: end;
    align-self: end;
    margin-right: 8%;
  }
  .img-4 {
    grid-area: 2 / 2 / 3 / 4;
    width: 53%;
    justify-self: end;
    margin-bottom: 1%;
  }
  .img-5 {
    grid-area: 2 / 4 / 4 / 6;
    width: 110%;
    height: 110%;
    align-self: center;
    margin-left: 3%;
  }
  .img-6 {
    grid-area: 3 / 1 / 4 / 2;
    width: 70%;
    height: 120%;
    justify-self: end;
    align-self: start;
  }
  .img-7 {
    grid-area: 3 / 2 / 4 / 4;
    width: 95%;
    height: 200%;
    justify-self: end;
  }
`
